/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import {map, Observable} from 'rxjs';

import {AdnApiClientService} from '../../common/controller/adn-api-client.service';
import {
  SignalAdminResourceApiBase,
  SignalAdminResourceModel,
  SignalAdminResourcePage
} from '../../common/controller/signal-admin-resource-api';

export interface TeamModel extends SignalAdminResourceModel {
  [key: string]: any;
}

@Injectable({providedIn: 'root'})
export class TeamApiService extends SignalAdminResourceApiBase<TeamModel> {
  constructor(client: AdnApiClientService) {
    super(client, 'teams');
  }

  listOptions(params: Record<string, any> = {}): Observable<SignalAdminResourcePage<TeamModel>> {
    return this.client.request<SignalAdminResourcePage<TeamModel>>({
      method: 'GET',
      url: this.resourceUri('teams'),
      params: {
        includeHidden: false,
        includeActive: true,
        includeInactive: false,
        orderBy: 'name',
        pageSize: 1001,
        ...params
      }
    });
  }

  saveDefaultTargeting(id: string, defaultTargeting: any): Observable<TeamModel> {
    return this.client.request<TeamModel>({
      method: 'POST',
      url: this.resourceUri('teams/' + encodeURIComponent(id)),
      body: {id, defaultTargeting}
    }).pipe(map((saved) => ({id, defaultTargeting, ...(saved || {})})));
  }
}
